import styled from 'styled-components';

export const VillaCardWrapper = styled.div(
  props => `
  margin-bottom: 10px;
  border: 1px solid #E1E7EE;
  border-radius: 10px;
  border: ${props.theme.misc.border.base} solid #e4e4e4;
  border-radius: ${props.theme.misc.borderRadius.xxxlarge};
  overflow: hidden;
  `,
);

export const VillaHeaderWrapper = styled.div(
  props => `
    display:flex;
    align-items:center;
    background: #E7F5EF;
    padding: 10px 0;
    border-bottom: 1px solid ${props.theme.colors.ash.dark};
    position: relative;
    height: 38px;
    overflow: hidden;
  `,
);

export const VillaIconWrapper = styled.span(
  props => `
  display: flex;
      background: #D1EFE2;
      padding: 8px;
      border-radius: 50%;
      background: #D1EFE2;
    padding: 8px;
    border-radius: 50%;
    width: 44px;
    height: 44px;
    flex-shrink: 0;
    margin-left: -11px;
    margin-right: 4px;
    align-items: center;
    justify-content: flex-end;
    `,
);

export const VillaHeader = styled.h4(
  props => `
    font-weight: 600;
font-size: 12px;
color: ${props.theme.colors.downriver.base}
  `,
);

export const VillaAreaText = styled.p(
  props => `
    font-size: 12px;
color: ${props.theme.colors.downriver.medium};
margin-left: 12px;
display: flex;
align-items: center;


&:before {
    content: '';
       display: inline-block;
       width: 4px;
       height: 4px;
       border-radius: 50%;
       background-color: ${props.theme.colors.downriver.medium};
       margin-right: 4px;
}
  `,
);

export const VillaListWrapper = styled.ul(
  props => `
      display:flex;
      align-items:center;
      justify-content: flex-start;
      padding: 8px 16px 12px;
      gap:1rem
    `,
);

export const VillaListItem = styled.li(
  props => `
      display:flex;
      flex-direction: column;
      flex-shrink: 0;
      width: 33%;
      align-items: flex-start;
     >  p:first-child {
        font-size: 12px;
        color: #4A4A4A;
        margin-bottom: 6px;
      }
    `,
);

export const ItemLogoWrapper = styled.p(
  props => `
  display:flex;
  align-items:center;
  justify-content: flex-start;
         > span {
             margin-left: 4px;
             font-weight: 600;
            font-size: 12px;
            color: #4A4A4A;
         }
      `,
);
